import React , { useState} from "react"
import { MagicLink } from "../utils/magicLink"
import { Flex, Box } from "theme-ui"
import AccordionClosed from "../images/accordion-closed.inline.svg"

const ArrowLink = ({theme, item, to=undefined, sx}) =>{
    
    const [ isHover, setIsHover ] = useState(false)
    return (
        <Flex
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        sx={{
          alignItems: "center",
          textTransform: "uppercase",
          fontWeight: "400",
          maxWidth:["350px","650px"],
          fontSize: [3, 4, 4, 5],
          justifyContent: "space-between",
          pt: [2, 3, 3, 4],
          mt: [2, 3, 3, 5],
          borderTop: "2px solid",
          borderColor: theme === "dark" ? "dark" :"primary",
          a: {
            textDecoration: "none",
          },
          ...sx
        }}
      >
        <MagicLink
          item={item}
          locale={item.locale}
          sx={{
            fontSize: [3, 4, 4, 5],
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
            color: theme === "dark" ? "dark" :"primary",
            svg:{
              maxWidth: ["28px", "39px"],
                      maxHeight: ["28px", "39px"],
              fill: theme === "dark" ? "dark" :"primary",
              transition: "all .2s ease",
            },
            "&:hover":{
              svg: {
                fill: theme === "dark" ? "dark" :"primary",
              },
            }
          }}
        >
          <Box>{item.anchor}</Box>
          <Box
            sx={{
              maxWidth:"39px",
              maxHeight:"39px",
              mr:isHover && [2],
              transform: isHover && "rotate(45deg)",
              transition: "all .2s ease",
              maxWidth: ["50%", "75%", "75%", "100%"],
            }}
          >
            <AccordionClosed />
          </Box>
        </MagicLink>
      </Flex>
    )
}

export default ArrowLink